import React from "react";
import { SECTIONS } from "../../../constants/appConstants";
import {
  IsSectionVisible,
  IsTenant,
  IsTenantAdmin
} from "../../../utils/helper";
import TenantViewContact from "./tenantViewContactTable";
import TenantViewTable from "./tenantViewTable";
import "./tenantView.less";
import { Button } from "@material-ui/core";
import { apiBatchRequest, apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import AddUpdateTenantContact from "../contact/addUpdateContact";
import uniqBy from "lodash/uniqBy";
import AddUpdateRequest from "../../Request/addUpdateRequest";
import { routes } from "../../../constants/routes";
import { Tenant_Contact_List } from "../../../constants/ssrs_api";
import DownloadSSRSPopUp from "../../common/button-download-popup";
import { downloadExcelReportByAPI } from "../../../utils/downloading";
import moment from "moment";

class TenantView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requestMasterData: null,
      userDetails: {},
      requestSupportMaster: null,
      tenantList: [],
      tenantId: 0,
      tenantsFromTenantView: [],
      isAddContactDialogOpen: false,
      isAddRequestOpen: false,
      isContactSaved: false,
      toolTipData: []
    };
  }


  componentDidMount() {
    //fetch list data
    this.getTenantList();
    this.getMasterData();
  }


  /**
   * get tenant contact list
   */
  getTenantList = () => {
    apiRequest({
      url: API_URL.tenant.GetTenants
    }).then(({ data: tenants }) => {
      this.setState({
        tenantList: tenants,
        tenantId: tenants && tenants.length > 0 ? tenants[0].TenantId : 0,
        tenantsFromTenantView: tenants && tenants.length > 0 ? tenants : []
      });
    });
  };

  /**
   * get master list
   */
  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.masterData.GetRequestMasterData,
        key: "requestMasterData"
      },
      {
        url: API_URL.request.GetUserSiteInfo,
        key: "userDetails"
      },
      {
        url: API_URL.request.GetRequestTypesForUser,
        key: "requestSupportMaster"
      },
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.ADD_UPDATE_CONTACT },
        key: "toolTipData"
      }
    ]).then(
      ({
        requestMasterData,
        userDetails,
        requestSupportMaster,
        toolTipData
      }) => {
        this.setState({
          requestMasterData: requestMasterData.data,
          userDetails: userDetails.data,
          requestSupportMaster: uniqBy(requestSupportMaster.data, function(x) {
            return [x.RequestTypeId, x.PropertyId].join();
          }),
          toolTipData: toolTipData.data || []
        });
      }
    );
  };

  /**
   * open add/update dialog
   * @param {*} isOpen
   */

  openAddUpdateDialogOpen = (isOpen = true) => {
    this.setState({ isAddContactDialogOpen: isOpen });
  };

  /**
   * refresh contacts list
   * @param {*} isContactSaved
   */
  refreshContacts = (isContactSaved = false) => {
    if (isContactSaved) {
      this.setState({ isContactSaved: true });
    }
    this.openAddUpdateDialogOpen(false);
  };

  /**
   * post request data
   */
  postRequest = () => {
    this.props.history.push({
      pathname: routes.requests,
      notificationProps: {
        isOpenRequest: true
      }
    });
  };

  /**
   * download SSRS excel or pdf
   * @param {*} report
   * @param {*} type
   */
  downloadSSRSReport = (report, type = "excel") => {
    const siteIds = "All";
    const fromDate = "IsNull=True";
    const toDate = "IsNull=True";
    const fromDateInvitation = "IsNull=True";
    const toDateInvitation = "IsNull=True";

    const fromDateExpiration = "IsNull=True";
    const toDateExpiration = "IsNull=True";

    const param = `&TenantContactStatus=${"InActive"}&DataCenter=${siteIds}&ContactName=${"All"}&OfficePhone=${"All"}&CellPhone=${"All"}&SearchEmail=${"All"}&RequestPermissions=${"All"}&TenantId=${0}${"&InvitationSentFromDate:" +
      fromDateInvitation}${"&InvitationSentToDate:" +
      toDateInvitation}${"&LastLoggedOnFromDate:" +
      fromDate}${"&LastLoggedOnToDate:" +
      toDate}&Role=${"All"}&DateOffset=${moment().utcOffset()}${"&ExpirationFromDate:" +
      fromDateExpiration}${"&ExpirationToDate:" + toDateExpiration}`;

    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }
  };

   /**
   * redirect api key management
   */
   apiKeyManagement = () => {
    this.props.history.push({
      pathname: routes.apiKeyManagement
    });
  };
  render() {
    const addContactVisible = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.ADD_UPDATE_CONTACT
    );

    const addRequestVisible = IsSectionVisible(
      SECTIONS.REQUEST,
      SECTIONS.CREATE_REQUEST
    );

    const {
      isAddContactDialogOpen,
      tenantId,
      tenantList,
      requestMasterData,
      isAddRequestOpen,
      userDetails,
      requestSupportMaster,
      isContactSaved,
      tenantsFromTenantView,
      toolTipData
    } = this.state;

    const isTenant = IsTenant();
    const isTenantAdmin = IsTenantAdmin();

    const isViewOnly = !isTenantAdmin && isTenant;

    return (
      <div className={"tenant-view"}>
        <div>
          {isAddContactDialogOpen && addContactVisible && requestMasterData && (
            <AddUpdateTenantContact
              isOpen={isAddContactDialogOpen}
              onClose={this.openAddUpdateDialogOpen}
              onSave={this.refreshContacts}
              tenantContactId={0}
              tenantId={tenantId}
              tenantsFromTenantView={tenantsFromTenantView}
              masterData={requestMasterData}
              toolTipData={toolTipData}
            />
          )}
          {isAddRequestOpen &&
            addRequestVisible &&
            userDetails &&
            requestSupportMaster &&
            requestSupportMaster && (
              <AddUpdateRequest
                masterData={requestMasterData}
                requestSupportMaster={requestSupportMaster}
                userDetails={userDetails}
                editableData={{ requestId: 0 }}
              />
            )}
            
        </div>
        <div className={"row"}>
          <div className={"col-xs-12 col-md-12 col-lg-6 btnGrp"}>
            {addRequestVisible && (
              <Button
                variant={"contained"}
                size={"small"}
                onClick={() => this.postRequest()}
              >
                {"Create Request\r"}
              </Button>
            )}
            {addContactVisible && !isViewOnly && (
              <Button
                variant={"contained"}
                size={"small"}
                onClick={() => this.setState({ isAddContactDialogOpen: true })}
              >
                {"Add User\r"}
              </Button>
            )}
            {IsTenantAdmin() && IsSectionVisible(
              SECTIONS.TENANT,
              SECTIONS.API_KEY_MANAGEMENT
              )  ?  <Button
                      variant={"contained"}
                      size={"small"}
                      onClick={() => this.apiKeyManagement()}
                    >
                    {"API Key Management"}
                    </Button> :
                ""}
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-xs-12 divider"}>
            <br />
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            {tenantList && <TenantViewTable tenantList={tenantList} />}
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-xs-12 divider"}>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div className={"row end-xs"}>
          <div className={"tenant-login-view"}>
            <DownloadSSRSPopUp
              buttonLabel={"Print"}
              dataTip={
                toolTipData?.find(b => b.UiColumnName == "Download")?.Tooltip
              }
              reportList={[
                {
                  label: "Tenant Contact List",
                  id: 1,
                  pdfDownload: true,
                  excelDownload: true,
                  downloadLink: Tenant_Contact_List
                }
              ]}
              downloadBtnLabel={"Download"}
              downloadReport={this.downloadSSRSReport}
            />
          </div>
        </div>

        <div className={"row"}>
          <div className={"col-xs-12"}>
            {requestMasterData && (
              <TenantViewContact
                masterData={requestMasterData}
                canAddContact={!isViewOnly}
                isContactSaved={isContactSaved}
                toolTipData={toolTipData}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default TenantView;
